// Listen out for any continuous integration updates
export default ({ app: { $echo, $logger, $toast, $inIframe }, store }) => {
  // do not init the store for an iframe (embed kintell card)
  if ($inIframe) {
    return
  }
  if (!$echo) {
    return
  }
  // ci is a public channel for all ci updates
  $logger.trace('Attached CI channel listeners', $echo.channel('ci')
    // New Client Update !
    .listen('.update', data => {
      const isNewVersion = process.env.VERSION !== data.version
      if (isNewVersion) {
        // Push a toast and set in your vuex that there is a new version
        $toast.info('A new version of Kintell has been released! We\'ll update to it when you change page :)', {
          duration: 10000
        })
        store.commit('kintell/SET_LATEST_VERSION', data.version)
      }
      $logger.info('Kintell Client Version Update', 'New: ' + data.version, 'Old: ' + process.env.version)
    })
  )
}
